import { twJoin } from 'tailwind-merge';

const sizeClasses = {
  sm: 'w-[144.5625px] h-[18px]',
  md: 'w-[192.75px] h-[24px]',
  lg: 'w-[257px] h-8',
  fluid: 'w-full h-full',
};

export default function LadderLogo({
  size = 'sm',
  className,
}: {
  size?: keyof typeof sizeClasses;
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 257.1 32"
      className={twJoin(sizeClasses[size], className)}
    >
      <path fill="white" d="M55.3,26.6V5h4.8v17.3h10.8v4.3h-15.6Z" />
      <path
        fill="white"
        d="M78.6,26.9c-3.1,0-5.7-1.8-5.7-5.1h0c0-3.7,2.8-5.3,6.7-5.3s2.9.3,4.1.7v-.3c0-1.9-1.2-3-3.6-3s-3.1.3-4.6.9l-1.2-3.6c1.8-.8,3.6-1.3,6.4-1.3s4.4.7,5.6,1.9c1.2,1.2,1.8,3.1,1.8,5.3v9.6h-4.5v-1.8c-1.1,1.3-2.7,2.1-5,2.1ZM80,23.7c2.2,0,3.7-1.2,3.7-2.9v-.8c-.8-.4-1.9-.6-3-.6-2,0-3.2.8-3.2,2.3h0c0,1.3,1.1,2.1,2.6,2.1Z"
      />
      <path
        fill="white"
        d="M99,26.9c-3.9,0-7.5-3-7.5-8.5h0c0-5.6,3.6-8.6,7.5-8.6s4.1,1.1,5.2,2.5V4.1h4.7v22.5h-4.7v-2.4c-1.1,1.5-2.7,2.7-5.2,2.7ZM100.2,23c2.2,0,4-1.8,4-4.6h0c0-2.8-1.8-4.6-4-4.6s-4.1,1.8-4.1,4.6h0c0,2.8,1.9,4.6,4.1,4.6Z"
      />
      <path
        fill="white"
        d="M119.9,26.9c-3.9,0-7.5-3-7.5-8.5h0c0-5.6,3.6-8.6,7.5-8.6s4.1,1.1,5.2,2.5V4.1h4.7v22.5h-4.7v-2.4c-1.1,1.5-2.7,2.7-5.2,2.7ZM121.1,23c2.2,0,4-1.8,4-4.6h0c0-2.8-1.8-4.6-4-4.6s-4.1,1.8-4.1,4.6h0c0,2.8,1.9,4.6,4.1,4.6Z"
      />
      <path
        fill="white"
        d="M141.8,27c-5,0-8.7-3.5-8.7-8.5h0c0-4.8,3.4-8.7,8.2-8.7s8.1,4.3,8.1,9,0,.8,0,1.2h-11.5c.5,2.1,1.9,3.2,4.1,3.2s2.7-.5,4-1.7l2.7,2.4c-1.5,1.9-3.8,3.1-6.8,3.1ZM137.7,17.1h7.1c-.3-2.1-1.5-3.5-3.5-3.5s-3.2,1.4-3.6,3.5Z"
      />
      <path
        fill="white"
        d="M152.9,26.6V10.1h4.7v3.3c1-2.3,2.5-3.8,5.3-3.6v4.9h-.2c-3.1,0-5,1.9-5,5.8v6.1h-4.7Z"
      />
      <path
        fill="white"
        d="M17.6,23.2v-14.3l12.4,7.1L39.3,0,0,16l39.3,16-9.3-16-12.4,7.1Z"
      />
      <g>
        <path
          className="fill-neutral-400"
          d="M175.9,5h9c5.3,0,8.4,3.1,8.4,7.6h0c0,5.2-4,7.8-8.9,7.8h-3.7v6.6h-4.9V5ZM184.6,16.1c2.4,0,3.8-1.4,3.8-3.3h0c0-2.2-1.5-3.4-3.9-3.4h-3.7v6.7h3.8Z"
        />
        <path
          className="fill-neutral-400"
          d="M196.3,21.1v-10.9h4.8v9.4c0,2.3,1.1,3.4,2.9,3.4s3-1.2,3-3.4v-9.4h4.8v16.9h-4.8v-2.4c-1.1,1.4-2.5,2.7-4.9,2.7-3.6,0-5.7-2.4-5.7-6.3Z"
        />
        <path className="fill-neutral-400" d="M216.2,4h4.8v23h-4.8V4Z" />
        <path
          className="fill-neutral-400"
          d="M224.2,24.8l2-3.1c1.8,1.3,3.7,2,5.3,2s2-.5,2-1.3h0c0-1.1-1.6-1.4-3.5-2-2.4-.7-5-1.8-5-5.1h0c0-3.5,2.8-5.4,6.2-5.4s4.5.7,6.3,2l-1.8,3.3c-1.7-1-3.3-1.6-4.6-1.6s-1.8.5-1.8,1.2h0c0,1,1.6,1.4,3.4,2.1,2.4.8,5.1,1.9,5.1,5h0c0,3.8-2.8,5.5-6.5,5.5s-5-.8-7.2-2.6Z"
        />
        <path
          className="fill-neutral-400"
          d="M240.5,18.7h0c0-4.9,3.4-8.8,8.3-8.8s8.2,4.4,8.2,9.2,0,.8,0,1.3h-11.7c.5,2.2,2,3.3,4.1,3.3s2.8-.5,4.1-1.7l2.7,2.4c-1.6,2-3.8,3.1-6.9,3.1-5.1,0-8.8-3.6-8.8-8.7ZM252.4,17.2c-.3-2.1-1.5-3.6-3.6-3.6s-3.3,1.4-3.7,3.6h7.2Z"
        />
      </g>
    </svg>
  );
}
